import { Button } from '@consigli/shadcn';
import { HiOutlinePlus } from 'react-icons/hi';

import { TemplatesTable } from './templates-table';
import { UploadTemplateForm } from './upload-template-form';

export const ReportTemplatesPage = () => {
  return (
    <div className="container mx-auto py-8 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Report Templates</h1>
          <p className="text-gray-600 mt-1">
            Manage report templates for different report types, project types, and locations
          </p>
        </div>
        <UploadTemplateForm
          trigger={
            <Button className="flex items-center gap-2">
              <HiOutlinePlus className="h-5 w-5" />
              Create Template
            </Button>
          }
        />
      </div>

      {/* Templates Table */}
      <TemplatesTable />
    </div>
  );
};
